<template>
    <div>
        <h1 style="font-size: 24px; color: black;">
            <el-page-header @back="goBack" content="活动配置">
            </el-page-header>
        </h1>
        <el-card shadow="never">
            <el-col style="padding-bottom: 15px">位置名称：{{ position.name }}
                <el-button class="sub-sub12" type="primary" @click="showDetail('新增活动')">新增活动</el-button>
            </el-col>
        </el-card>
        <h1>
            <el-table :data="activityList"
                      border
                      :fit="true">
                <el-table-column label="活动ID" prop="id" align="center"></el-table-column>
                <el-table-column label="活动名称" prop="name" align="center"></el-table-column>
                <el-table-column label="跳转类型" prop="openJumpTypeEnum.name" align="center"></el-table-column>
                <el-table-column label="vip类型" prop="userVipEnum.name" align="center"></el-table-column>
                <el-table-column label="用户类型" align="center" prop="userNewEnum.name"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="跳转地址" prop="url" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="图片" align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.img" width="80px" height="80px"/>
                        </template>
                    </template>
                </el-table-column>


                <el-table-column label="渠道" align="center" width="200px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.subChannelName === 0 ? '' : scope.row.subChannelName.join(" , ") }}
                    </template>
                </el-table-column>

                <el-table-column label="生效时间" prop="startDt" align="center"
                                 :formatter="formatDate"></el-table-column>
                <el-table-column label="失效时间" prop="endDt" align="center" :formatter="formatDate"></el-table-column>
                <el-table-column label="状态" prop="state" align="center"></el-table-column>

                <el-table-column label="点击是否关闭" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.closeClick === true">是</span>
                        <span v-if="scope.row.closeClick === false">否</span>
                    </template>
                </el-table-column>

                <el-table-column label="是否有关闭按钮" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.closeButton === true">显示</span>
                        <span v-if="scope.row.closeButton === false">隐藏</span>
                    </template>
                </el-table-column>

                <el-table-column label="苹果开始版本" prop="iosStart"></el-table-column>
                <el-table-column label="苹果结束版本" prop="iosEnd"></el-table-column>
                <el-table-column label="安卓开始版本" prop="androidStart"></el-table-column>
                <el-table-column label="安卓结束版本" prop="androidEnd"></el-table-column>
                <el-table-column label="鸿蒙开始版本" prop="harmonyStart"></el-table-column>
                <el-table-column label="鸿蒙结束版本" prop="harmonyEnd"></el-table-column>
                <el-table-column label="排序" prop="ranking" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="180px">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="success" @click="showDetail('编辑活动',scope.row)">编辑
                        </el-button>
                        <el-button plain size="mini" type="danger" @click="deleteActivity(scope.row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </h1>
        <el-row>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[20,50,100]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </el-row>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="700px">
            <el-form :model="activityEditForm" label-width="150px">
                <el-form-item label="活动名称:">
                    <el-input style="width: 300px" type="text" v-model="activityEditForm.name"></el-input>
                </el-form-item>
                <el-form-item label="跳转类型:">
                    <el-select v-model="activityEditForm.jumpType">
                        <el-option
                            v-for="item in openJumpTypeEnum"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="vip类型:">
                    <el-select v-model="activityEditForm.userVip">
                        <el-option
                            v-for="item in userVipEnum"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="显示规则:">
                    <el-select v-model="activityEditForm.openRule">
                        <el-option
                            v-for="item in openRuleEnum"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户类型:">
                    <el-select v-model="activityEditForm.userNew">
                        <el-option
                            v-for="item in userNewEnum"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="跳转地址:">
                    <el-input v-if="activityEditForm.jumpType===1" v-model="activityEditForm.url"></el-input>
                    <el-select v-if="activityEditForm.jumpType===2" v-model="activityEditForm.url">
                        <el-option
                            v-for="item in openShowTypeEnum"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="图片 :">
                    <el-tag type="danger">图片不大于1mb</el-tag>
                    <el-upload
                        :headers="headers"
                        class="avatar-uploader"
                        :action="uploadURL"
                        :show-file-list="false"
                        :on-success="handleBISuccess"
                        :before-upload="function (file) { return beforeAvatarUpload(file)}"
                        @click="uploadIcon">
                        <img v-if="activityEditForm.img" :src="VUE_APP_CDN_URL+activityEditForm.img"
                             class="avatar">
                        <i v-else class="el-icon-img avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="渠道:">
                    <el-select multiple filterable v-model="activityEditForm.subChannels">
                        <el-option
                            v-for="item in iosGatherChannelList"
                            :label="item.channel"
                            :value="item.id"
                            :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="有效期:">
                    <el-date-picker
                        v-model="activityEditForm.startDt"
                        type="datetime"
                        placeholder="开始时间">
                    </el-date-picker>
                    <span>至</span>
                    <el-date-picker
                        v-model="activityEditForm.endDt"
                        type="datetime"
                        placeholder="结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-button type="primary" size="small" style="margin-left:10px" @click="()=>{const now=new Date();if(activityEditForm.startDt&&new Date(activityEditForm.startDt)>now)activityEditForm.startDt=now;activityEditForm.endDt=new Date('2099-12-31 23:59:59')}">快速上架</el-button><el-button type="warning" size="small" style="margin-left:6px" @click="()=>{const now=new Date();activityEditForm.startDt=now;activityEditForm.endDt=now}">快速下架</el-button>
                <el-form-item label="点击是否关闭:">
                    <el-radio-group v-model="activityEditForm.closeClick">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="关闭按钮:">
                    <el-radio-group v-model="activityEditForm.closeButton">
                        <el-radio :label="true">显示</el-radio>
                        <el-radio :label="false">隐藏</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否首日展示:">
                    <el-radio-group v-model="activityEditForm.showFirstDay">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否倒计时:">
                    <el-radio-group v-model="activityEditForm.last">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="间隔时间（天）">

                    <el-input-number v-model="activityEditForm.intervalDays" :step="1"></el-input-number>
                </el-form-item>
                <el-form-item label="展示天数">

                    <el-input-number v-model="activityEditForm.showDays" :step="1"></el-input-number>
                </el-form-item>
                <el-form-item label="倒计时（小时）">

                    <el-input-number v-model="activityEditForm.lastHours" :step="1"></el-input-number>
                </el-form-item>

                <el-form-item label="苹果开始版本号">

                    <el-input-number v-model="activityEditForm.iosStart" :step="1"></el-input-number>
                </el-form-item>
                <el-form-item label="苹果结束版本号">

                    <el-input-number v-model="activityEditForm.iosEnd" :step="1"></el-input-number>
                </el-form-item>
                <el-form-item label="安卓开始版本号">

                    <el-input-number v-model="activityEditForm.androidStart" :step="1"></el-input-number>
                </el-form-item>
                <el-form-item label="安卓结束版本号">

                    <el-input-number v-model="activityEditForm.androidEnd" :step="1"></el-input-number>
                </el-form-item>

                <el-form-item label="鸿蒙开始版本号">

                    <el-input-number v-model="activityEditForm.harmonyStart" :step="1"></el-input-number>
                </el-form-item>
                <el-form-item label="鸿蒙结束版本号">

                    <el-input-number v-model="activityEditForm.harmonyEnd" :step="1"></el-input-number>
                </el-form-item>

                <el-form-item label="排序">

                    <el-input-number v-model="activityEditForm.ranking" :step="1"></el-input-number>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirm">确 定</el-button>
                    <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import {allOperationPositionActivity, allSelect, deleteOPActivity, editOPActivity} from "@/http/cgApi";
import {gameUpload} from "@/http/api";
import utils from '@/utils';
import settingMix from '@/utils/mix/common-setting'

export default {
    mixins: [settingMix],
    name: "OperationConfigDetailCatGather",
    data() {
        return {
            position: {},
            headers: {},
            channelList: [],
            uploadURL: process.env.VUE_APP_BASE_URL + "game/upload",
            activityList: [],
            queryTrueData: {},
            VUE_APP_BASE_URL: '',
            VUE_APP_CDN_URL: '',
            userNewEnum: [],
            openRuleEnum: [],
            openJumpTypeEnum: [],
            openShowTypeEnum: [],
            openShowTypeMap: {},
            userVipEnum: [],
            dialogVisible: false,
            dialogTitle: '',
            optionProps: {
                emitPath: false,
                multiple: true,
                value: 'subChannel',
                label: 'name',
                children: 'children',
            },
            activityEditForm: {},
            page: {
                size: 20,
                page: 1,
                totalElements: null
            },
            needGatherChannel: true,
            iosGatherChannelList: [],
            iosGatherChannelObject: {},
        }
    },
    methods: {
        formatDate: function (row, column, cellValue) {
            return utils.DateUtil.formatDate(cellValue, "yyyy-MM-DD HH:mm:ss")
        },
        goBack() {
            this.$router.push({path: '/operationConfigCatGather'});
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.queryList();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.queryList();
        },
        handleBISuccess(response) {
            this.activityEditForm.img = response.info;
        },
        uploadIcon() {
            let func = gameUpload;
            func().then().catch(function () {
            })
        },
        handleVideoSuccess(response) {
            this.activityEditForm.video = response.info;
        },
        beforeAvatarUpload(file) {
            const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/gif';
            const isLt2M = file.size / 1024 / 1024 < 1;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过1MB!');
            }
            if (!isIcon) {
                this.$message.error('上传图片只能是png,jgp,jpeg,gif格式!');
            }
            return isIcon && isLt2M;
        },
        showDetail: function (title, row) {
            allSelect().then(resp => {
                this.userNewEnum = resp.data.info.userNewEnum;
                this.openRuleEnum = resp.data.info.openRuleEnum;
                this.openJumpTypeEnum = resp.data.info.openJumpTypeEnum;
                this.userVipEnum = resp.data.info.userVipEnum;
                this.openShowTypeEnum = resp.data.info.openShowTypeEnum;
                for (let i = 0; i < this.openShowTypeEnum.length; i++) {
                    var name = this.openShowTypeEnum[i].name;
                    var id = this.openShowTypeEnum[i].id;
                    this.openShowTypeMap[name] = id;
                }
            });
            this.activityEditForm = {
                "id": 0,
                "name": "",
                "jumpType": 2,
                "openId": this.position.id,
                "img": "",
                "startDt": '',
                "endDt": '',
                "openRule": 2,
                "userNew": 2,
                "closeClick": true,
                "closeButton": true,
                "subChannels": [],
                "ranking": 1,
                "iosStart": 1,
                "iosEnd": 9999,
                "androidStart": 1,
                "harmonyStart": 1,
                "userVip": 2,
                "openJumpType": 2,
                "androidEnd": 9999,
                "harmonyEnd": 9999,
                "intervalDays": 0,
                "showDays": false,
                "showFirstDay": 0,
                "lastHours": 0,
                "last": false,
            };

            this.dialogTitle = title;
            this.dialogVisible = true;

            if (row) {
                this.activityEditForm = {
                    "id": row.id,
                    "name": row.name,
                    "jumpType": row.jumpType,
                    "openId": row.openId,
                    "url": row.url,
                    "img": row.img,
                    "startDt": row.startDt,
                    "endDt": row.endDt,
                    "openRule": row.openRule,
                    "userNew": row.userNew,
                    "closeClick": row.closeClick,
                    "closeButton": row.closeButton,
                    "subChannels": row.subChannel,
                    "ranking": row.ranking,
                    "userVip": row.userVip,
                    "iosStart": row.iosStart,
                    "iosEnd": row.iosEnd,
                    "androidStart": row.androidStart,
                    "harmonyStart": row.harmonyStart,
                    "androidEnd": row.androidEnd,
                    "harmonyEnd": row.harmonyEnd,
                    "intervalDays": row.intervalDays,
                    "showDays": row.showDays,
                    "showFirstDay": row.showFirstDay,
                    "lastHours": row.lastHours,
                    "last": row.last,
                };
            }
        },
        deleteActivity(id) {
            this.$confirm('此操作将删除活动, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteOPActivity(id).then(resp => {
                    if (resp.data.status === 0) {
                        this.queryList();
                    }
                });
            }).catch(() => {
            })

        },
        confirm() {
            if (this.activityEditForm.startDt === "" || this.activityEditForm.endDt === "") {
                this.$message.error('开始结束日期必填');
                return;
            }
            if (this.activityEditForm.jumpType === 2) {
                let name = this.activityEditForm.url;
                let n = this.openShowTypeMap[name];
                if (n !== null && n !== undefined) {
                    this.activityEditForm.url = n;
                }
            }
            editOPActivity(this.activityEditForm).then(resp => {
                if (resp.data.status === 0) {
                    this.queryList();
                    this.dialogVisible = false;
                }
            });
        },
        queryList() {
            this.queryTrueData.size = this.page.size;
            this.queryTrueData.page = this.page.page;
            allOperationPositionActivity(this.queryTrueData).then(resp => {
                this.activityList = resp.data.info.content;
                this.$forceUpdate();
                this.page.totalElements = resp.data.info.totalElements;
            });
        },
    },
    created() {
        this.headers = {Authorization: this.$store.state.user.token};
        this.position = this.$store.state.position;
        this.queryTrueData.openId = this.$store.state.position.id;
        this.queryList();
    },
    mounted() {
        this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
        this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
    }
}
</script>

<style scoped>
.sub-sub12 {
    position: relative;
    left: 1200px
}
</style>